import React from 'react';
import {RadioButton} from 'material-ui/RadioButton';
import RangeField from 'components/pure/utils/form/RangeField';
import './CallConversationSelectionStyles.styl';
import {CallConditionType} from 'records/CallTrigger';

export default class CallConversationSelection extends React.Component {
  constructor(props) {
    super(props);

    this.amountRangeChange = this.amountRangeChange.bind(this);
  }

  amountRangeChange(value) {
    this.props.selectedValueChanged(value);
  }

  render() {
    const {selectedContextType, selectedValue} = this.props;
    const {start, end} = ([
      CallConditionType.CONVERSATION_LENGTH,
      CallConditionType.TALK_LISTEN_RATIO,
      CallConditionType.INTERCHANGES,
    ].includes(selectedContextType) &&
      selectedValue) || {start: 0, end: 0};
    return (
      <div className="call-conversation-select">
        <ul>
          <li>
            <div className="radio-select-field">
              <div className="radio-wrapper">
                <RadioButton
                  label="Conversation length is"
                  checked={selectedContextType === CallConditionType.CONVERSATION_LENGTH}
                  onClick={() =>
                    this.props.selectedContextTypeChanged(CallConditionType.CONVERSATION_LENGTH, {
                      start: 0,
                      end: 7200,
                    })
                  }
                />
              </div>
              {selectedContextType === CallConditionType.CONVERSATION_LENGTH && (
                <div className="range-inputs">
                  <RangeField
                    start={Math.round(start / 60)}
                    end={Math.round(end / 60)}
                    onValueChange={value =>
                      this.amountRangeChange({
                        start: value.start * 60,
                        end: value.end * 60,
                      })
                    }
                    range={{start: 0, end: 120}}
                    showInputRange={true}
                    suffix="minutes"
                    disabled={selectedContextType !== CallConditionType.CONVERSATION_LENGTH}
                  />
                </div>
              )}
            </div>
          </li>
          <li>
            <div className="radio-select-field">
              <div className="radio-wrapper">
                <RadioButton
                  label="Call was scheduled"
                  checked={
                    selectedContextType === CallConditionType.CALL_SCHEDULED &&
                    selectedValue === true
                  }
                  onClick={() =>
                    this.props.selectedContextTypeChanged(CallConditionType.CALL_SCHEDULED, true)
                  }
                />
              </div>
            </div>
          </li>
          <li>
            <div className="radio-select-field">
              <div className="radio-wrapper">
                <RadioButton
                  label="Call was unscheduled"
                  checked={
                    selectedContextType === CallConditionType.CALL_SCHEDULED &&
                    selectedValue === false
                  }
                  onClick={() =>
                    this.props.selectedContextTypeChanged(CallConditionType.CALL_SCHEDULED, false)
                  }
                />
              </div>
            </div>
          </li>
          <li>
            <div className="radio-select-field">
              <div className="radio-wrapper">
                <RadioButton
                  label="Talk/Listen ratio"
                  checked={selectedContextType === CallConditionType.TALK_LISTEN_RATIO}
                  onClick={() =>
                    this.props.selectedContextTypeChanged(CallConditionType.TALK_LISTEN_RATIO, {
                      start: 75,
                      end: 100,
                    })
                  }
                />
              </div>
              {selectedContextType === CallConditionType.TALK_LISTEN_RATIO && (
                <div className="range-inputs">
                  <RangeField
                    start={start}
                    end={end}
                    onValueChange={this.amountRangeChange}
                    formatLabel={value => ''}
                    showInputRange={true}
                    suffix="% talk"
                    disabled={selectedContextType !== CallConditionType.TALK_LISTEN_RATIO}
                  />
                </div>
              )}
            </div>
          </li>
          <li>
            <div className="radio-select-field">
              <div className="radio-wrapper">
                <RadioButton
                  label="Has interchanges per minute"
                  checked={selectedContextType === CallConditionType.INTERCHANGES}
                  onClick={() =>
                    this.props.selectedContextTypeChanged(CallConditionType.INTERCHANGES, {
                      start: 1,
                      end: 2,
                    })
                  }
                />
              </div>
              {selectedContextType === CallConditionType.INTERCHANGES && (
                <div className="range-inputs">
                  <RangeField
                    start={start}
                    end={end}
                    onValueChange={this.amountRangeChange}
                    formatLabel={value => ''}
                    range={{start: 1, end: 10}}
                    showInputRange={true}
                    suffix="/ min"
                    disabled={selectedContextType !== CallConditionType.INTERCHANGES}
                  />
                </div>
              )}
            </div>
          </li>
        </ul>
      </div>
    );
  }
}
